var map = {
	"./symbol_0.png": 89605,
	"./symbol_1.png": 76540,
	"./symbol_2.png": 60823,
	"./symbol_3.png": 17806,
	"./symbol_4.png": 70273,
	"./symbol_5.png": 85656,
	"./symbol_6.png": 60147,
	"./symbol_7.png": 21290,
	"./symbol_8.png": 55357,
	"./symbol_9.png": 34228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75928;